import container from "../../libs/container/container";

const amdAboutPurposeModule = (function () {
    const name = 'about__purpose-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPurposeHeaderBigAreaCls, 'animate__fadeInLeft25P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPurposeContentAreaCls, 'animate__fadeInRight25P', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdAboutPurposeModule;